import React from 'react';
import _ from 'lodash';
import QuillDeltaToHtmlConverter from 'quill-delta-to-html';
import { dp } from '../../../utils/shared.js';

export default (props) => {
  
  const headlineOps = _.get(props.headline, 'val.ops');
  const headlineOpsInstance = new QuillDeltaToHtmlConverter(headlineOps, {});
  const headlineOpsRichText = headlineOpsInstance.convert();

  const quoteOps = _.get(props.quote, 'val.ops');
  const quoteOpsInstance = new QuillDeltaToHtmlConverter(quoteOps, {});
  const quoteOpsRichText = quoteOpsInstance.convert();

  const bodyOps = _.get(props.body, 'val.ops');
  const bodyOpsInstance = new QuillDeltaToHtmlConverter(bodyOps, {});
  const bodyOpsRichText = bodyOpsInstance.convert();

  const imgSrc = dp(props.screen, props.images[0], { path: '/img/ui/', file_name: 'image_default.png' });
  
  return (
    <div className="denver-stories__content">
      <div className="denver-stories__story-1">
        <img src={imgSrc} style={{ height: '27.6vh', marginBottom: '1.75vh', maxWidth: "100%" }} alt=""/>
        <div className="denver-stories__heading ql-editor" dangerouslySetInnerHTML={{ __html: headlineOpsRichText }}></div>
        
        <blockquote className="denver-stories__quote ql-editor" dangerouslySetInnerHTML={{ __html: quoteOpsRichText }}></blockquote>

        <div className="denver-stories__main-copy" dangerouslySetInnerHTML={{ __html: bodyOpsRichText }}/>
      </div>  
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/Components/Theme/Denver/DenverStory1.js